import DataTable from '@visa/vds/data-table';
import ScreenReader from '@visa/vds/screen-reader';
import Tbody from '@visa/vds/tbody';
import Td from '@visa/vds/td';
import Th from '@visa/vds/th';
import Thead from '@visa/vds/thead';
import Tr from '@visa/vds/tr';
import Typography from '@visa/vds/typography';
import React, { useEffect, useState } from 'react';
import { AlignRight, GetUSDCurrencyString, applyFeeWaiverToProductFee, applyFeeWaiverToSetupFee, findProductToApplyFeeWaiver } from '../FeeWaiver/FeeWaiverLogic';
import { ProductSelectionConst } from '../SelectProduct/ProductSelectionLogic';

const VSTTOrderSummaryTable = (props) => {
    const [recurringFeeDiscount, setRecurringFeeDiscount] = useState(0);
    const [setupFeeDiscount, setSetupFeeDiscount] = useState(0);    

    useEffect(() => {
        if (!props.selectedFeeWaiver) return;

        const product = findProductToApplyFeeWaiver(props.orderSummaryProductsList, props.selectedFeeWaiver);
        const _recurringFeeDiscount = applyFeeWaiverToProductFee(product, props.selectedFeeWaiver);
        const _setupFeeDiscount = applyFeeWaiverToSetupFee(product, props.selectedFeeWaiver);
        setRecurringFeeDiscount(_recurringFeeDiscount);
        setSetupFeeDiscount(_setupFeeDiscount);

        props.setTotalVSTTMonthlyFee(props.totalVSTTMonthlyFee + _recurringFeeDiscount);
        props.setTotalVSTTSetupFee(props.totalVSTTSetupFee + _setupFeeDiscount);
    }, [props.orderSummaryProductsList, props.selectedFeeWaiver])

    const shouldShowSetupFee = () => {
        return props.totalVSTTSetupFee != 0 || setupFeeDiscount != 0;
    }

    const shouldShowMonthlyFee = () => {
        return props.totalVSTTMonthlyFee != 0 || recurringFeeDiscount != 0
    }

    const shouldShowYearlyFee = () => {
        return props.totalVSTTYearlyFee != 0
    }

    const calculateRowSpan = (product) => {
        var rowSpan = 1;
        if (product.hasSetUp) rowSpan += 1;
        if (props.selectedFeeWaiver && props.selectedFeeWaiver.productId === product.productId) rowSpan += 1;
        return rowSpan;
    }

    const renderHeader = () => {
        return (
            <>
                { shouldShowSetupFee() ? <Th style={AlignRight} >One Time Fee</Th> : ""}
                { shouldShowMonthlyFee() ?<Th style={AlignRight} >Monthly Fee</Th> : ""}
                { shouldShowYearlyFee() ?<Th style={AlignRight} >Yearly Fee</Th> : ""}
            </>
        );
    };

    return (
        <>
            <DataTable className="table-subscription" size='compact'>
                <ScreenReader tag="caption">Order Summary Table</ScreenReader>
                <Thead>
                    <Tr>
                        <Th scope="col">Product</Th>
                        <Th>Item</Th>
                        {renderHeader()}
                    </Tr>
                </Thead>
                <Tbody>
                    {props.orderSummaryProductsList && props.orderSummaryProductsList.map((product, key) => (
                    <>
                        {product.hasSetUp &&
                        <Tr>
                            <Td rowSpan={calculateRowSpan(product)} className="vstt-order-review-table-product-name">
                                <Typography tag="h4" variant="headline"><b id={product.productId + " product-type"}>{product.productName}</b></Typography>
                            </Td>
                            <Td>
                                <Typography className="vstt-order-review-table-item-name" variant="headline--alt"><b>{product.setUpSubscription.productInfoName} (One Time Fee)</b></Typography>
                            </Td>
                            {shouldShowSetupFee() && <Td style={AlignRight} id={product.productId + " " + product.setUpSubscription.productInfoName + "-one-time-fee"}>{GetUSDCurrencyString(product.setUpSubscription.fee)}</Td>}
                            {shouldShowMonthlyFee() && <Td style={AlignRight} id={product.productId + " " + product.setUpSubscription.productInfoName + "-monthly-fee"}/>}
                            {shouldShowYearlyFee()  && <Td style={AlignRight}/>}
                        </Tr>}
                        <Tr>
                            {!product.hasSetUp &&
                            <Td rowSpan={calculateRowSpan(product)} className="vstt-order-review-table-product-name">
                                <Typography tag="h4" variant="headline"><b>{product.productName}</b></Typography>
                            </Td>}
                            <Td>
                                <Typography className="vstt-order-review-table-item-name" variant="headline--alt"><b>{product.productInfoName} (Recurring Fee)</b></Typography>
                            </Td>
                            {shouldShowSetupFee() && <Td style={AlignRight} id={product.productId  + " " + product.productInfoName + "-one-time-fee"}/>}
                            {shouldShowMonthlyFee() && <Td style={AlignRight} id={product.productId  + " " + product.productInfoName + "-monthly-fee"}>{product.recurringIntervalType == ProductSelectionConst.MONTHLY_SUBSCRIPTION_INTERVAL && GetUSDCurrencyString(product.fee)}</Td>}
                            {shouldShowYearlyFee() && <Td style={AlignRight} id={product.productId  + " " + product.productInfoName + "-yearly-fee"}>{product.recurringIntervalType == ProductSelectionConst.YEARLY_SUBSCRIPTION_INTERVAL && GetUSDCurrencyString(product.fee)}</Td>}
                        </Tr>
                        {props.selectedFeeWaiver && props.selectedFeeWaiver.productId === product.productId && 
                        <Tr>
                            <Td>
                                <Typography className="vstt-order-review-table-item-name" variant="headline--alt"><b>Fee Waiver or Fee Discount Applied:</b> {props.selectedFeeWaiver.description}</Typography>
                            </Td>
                            {shouldShowSetupFee() &&
                                <Td style={AlignRight}>
                                    {setupFeeDiscount != 0 &&
                                        <Typography className="order-review-table-fee-waiver-value" id="one-time-fee-waiver">{GetUSDCurrencyString(setupFeeDiscount)}</Typography>
                                    }
                                </Td>
                            }
                            {shouldShowMonthlyFee() &&
                                <Td style={AlignRight}>
                                    {recurringFeeDiscount != 0 &&
                                        <Typography id="recurring-fee-waiver" className="order-review-table-fee-waiver-value">{GetUSDCurrencyString(recurringFeeDiscount)}</Typography>
                                    }
                                </Td>
                            }
                            {shouldShowYearlyFee() && <Td style={AlignRight}/>}
                        </Tr>}
                    </>
                    ))}
                    <Tr className="total-tr">
                        <Td><Typography className="total-header" tag="h4" variant="headline--alt"><b>Total</b></Typography></Td>
                        <Td style={AlignRight}></Td>
                        {shouldShowSetupFee() && <Td style={AlignRight}><b id="total-setup-fees">{GetUSDCurrencyString(props.totalVSTTSetupFee)}</b></Td>}
                        {shouldShowMonthlyFee() && <Td style={AlignRight}><b id="total-monthly-fees">{GetUSDCurrencyString(props.totalVSTTMonthlyFee)}</b></Td>}
                        {shouldShowYearlyFee() &&<Td style={AlignRight}><b id="total-yearly-fees"> {GetUSDCurrencyString(props.totalVSTTYearlyFee)}</b></Td>}
                    </Tr>
                </Tbody>
            </DataTable>
        </>
    )
}

export default VSTTOrderSummaryTable